module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.getters.audio),
      expression: "$store.getters.audio"
    }]
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "outline": "",
      "color": "grey",
      "id": "btn-toggle"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('v-icon', [_vm._v("fullscreen_exit")]) : _c('v-icon', [_vm._v("fullscreen")])], 1)], 1), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.show
    },
    attrs: {
      "id": "external-player"
    }
  }, [_c('youtube-player'), _vm._v(" "), _c('app-player')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-116fa487","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayerExternalPlayer.vue
// module id = 346
// module chunks = 0